import request from "@/utils/request";

//获取详情
export function getRlist (params) {
    return request({
      url: 'copyrightApi/storage/evidence/my/list',
      method: 'get',
      params: params,
    })
}
//存证作品所有者
export function searchUserByKeyword (params) {
    return request({
      url: 'userApi/userInfo/searchUserByKeyword',
      method: 'post',
      params: params,
    })
}
//存证编辑
export function postUpdate (data) {
    return request({
      url: 'copyrightApi/storage/evidence/update',
      method: 'post',
      data: data,
    })
}
//存证提交
export function postCollect (data) {
    return request({
      url: 'copyrightApi/storage/evidence/info/collect',
      method: 'post',
      data: data,
    })
}
//存在删除
export function postCdelete (params) {
    return request({
        url: 'copyrightApi/storage/evidence/delete',
        method: 'post',
        params: params,
    })
}
